import { Rotation } from 'src/types/ViewModel/Rotation';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';

/**
 * Updates a rotation with data from a stowage plan
 */
// TODO: FUNCTION-MUTATION - Function mutates input rotation parameter, consider returning updated rotation instead
export const updateRotationWithStowagePlanData = (rotation: Rotation, stowagePlan: StowagePlan): void => {
    rotation.stowagePlanName = stowagePlan.title;
    rotation.lastUpdatedUtc = stowagePlan.lastUpdatedUtc;
    rotation.lastImosSynchronizedUtc = stowagePlan.syncedWithImosDateTimeUtc;
};
